export default __webpack_public_path__ + "static/media/business.6f680019.png";